import { useState, useEffect } from "react";
import { Input } from "../../../components/ui/input";

interface EditableCellProps {
	getValue: () => unknown;
	rowIndex: number;
	columnId: string;
	isEditable: boolean;
	onUpdate: (rowIndex: number, columnId: string, value: unknown) => void;
	className?: string;
}

export const EditableCell: React.FC<EditableCellProps> = ({
	getValue,
	rowIndex,
	columnId,
	isEditable,
	onUpdate,
	className = "",
}) => {
	const initialValue = getValue();
	const [value, setValue] = useState(initialValue);
	const [isEditing, setIsEditing] = useState(false);

	// Sync with external changes
	useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	const handleSave = () => {
		onUpdate(rowIndex, columnId, value);
		setIsEditing(false);
	};

	const handleCancel = () => {
		setValue(initialValue);
		setIsEditing(false);
	};

	// Read-only display for non-editable cells
	if (!isEditable) {
		return (
			<span className={className}>
				{(value as string) || "-"}
			</span>
		);
	}

	// Edit mode
	if (isEditing) {
		return (
			<Input
				type="text"
				value={(value as string) || ""}
				onChange={(e) => setValue(e.target.value)}
				onBlur={handleSave}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						e.preventDefault();
						handleSave();
					} else if (e.key === "Escape") {
						handleCancel();
					}
				}}
				autoFocus
				className="h-8 py-1 px-2"
			/>
		);
	}

	// View mode for editable cells
	return (
		<div
			onClick={() => setIsEditing(true)}
			className={`cursor-pointer hover:bg-gray-50 px-2 py-1 rounded transition-colors ${className}`}
			title="Klicken zum Bearbeiten"
		>
			{(value as string) || "-"}
		</div>
	);
};